import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function BillingCancel() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4" data-testid="billing-cancel-page">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl border border-gray-100 p-8 text-center">
        <XCircle className="w-12 h-12 text-rose-500 mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Checkout canceled</h1>
        <p className="text-gray-600 text-sm mb-6">No charge was made. You can upgrade anytime.</p>
        <Link to="/">
          <Button data-testid="billing-go-home-btn" className="w-full h-12 rounded-full bg-gradient-to-r from-primary to-emerald-600 text-white font-semibold">
            Back to Home
          </Button>
        </Link>
      </div>
    </div>
  );
}
